<template>
  <div class="seniorVolunteer">
    <header>
      <headComponent />
    </header>
    <div class="slider">
      <el-carousel height="450px">
        <el-carousel-item v-for="(item,index) in sliderList" :key="index">
          <div class="box">
            <div class="left">
              <div class="title" v-text="item.title"></div>
              <div class="text" v-html="item.info"></div>
            </div>
            <div class="right">
              <div class="img">
                <img :src="item.src" alt="">
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="help">
      <div class="title">
        <h4>传统志愿怎么填？</h4>
      </div>
      <div class="content">
        <div class="helpListBox">
          <div
            class="box"
            v-for="(item,index) in helpList"
            :key="index">
            <div class="img">
              <img :src="item.src" alt="">
            </div>
            <div class="name" v-text="item.name"></div>
            <p class="text" v-text="item.text"></p>
          </div>
        </div>
        <div class="arrHelpListBox">
          <div
            class="box"
            v-for="(item,index) in arrHelpList"
            :key="index">
            <img src="../../assets/img/gaobao/x.png" alt="">
            <span>{{item}}</span>
          </div>
        </div>
        <div class="info">
          <p>据不完全统计，85%的学生进入大学后，后悔自己当年填报的高考志愿</p>
          <p>海量的高校招生信息眼花缭乱，学生和家长对填报规则一知半解，盲目填报志愿</p>
        </div>
      </div>
    </div>
    <div class="platform">
      <div class="title">高招教育</div>
      <div class="info">
        <i>✓</i>
        <span>专为高中生打造的一站式升学发展服务平台</span>
      </div>
      <div class="listBox">
        <div
          class="box"
          v-for="(item,index) in platformList"
          :key="index">
          <div class="img">
            <img :src="item.src" alt="">
          </div>
          <div class="name" v-text="item.name"></div>
        </div>
      </div>
    </div>
    <div class="serveBox">
      <div class="title">专业的志愿填报服务</div>
      <div class="info">
        <span>结合学生学科特长、兴趣特点、未来发展规划</span>
      </div>
      <div class="serveListBox">
        <div class="top">
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/a.png" alt="">
              <span>初步沟通，洽谈签约</span>
            </div>
            <p
            title="初步了解学生基本信息，家长和考生的志愿意向，考生和家长了解服务流程，预约专业服务，支付服务费用，签订服务协议。"
            >初步了解学生基本信息，家长和考生的志愿意向，考生和家长了解服务流程，预约专业服务，支付服务费用，签订服务协议。</p>
          </div>
          <div class="rightArrows">
            <img src="../../assets/img/gaobao/jt.png" alt="">
          </div>
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/b.png" alt="">
              <span>学生情况分析</span>
            </div>
            <p
              title="深入了解学生学习成绩、学科特长、身体条件、家庭情况，以及目标专业、目标大学、目标城市，以及毕业后的发展规划（如就业、考研、考公、出国等）。"
              >深入了解学生学习成绩、学科特长、身体条件、家庭情况，以及目标专业、目标大学、目标城市，以及毕业后的发展规划（如就业、考研、考公、出国等）。</p>
          </div>
          <div class="rightArrows">
            <img src="../../assets/img/gaobao/jt.png" alt="">
          </div>
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/c.png" alt="">
              <span>测评结果解读</span>
            </div>
            <p
              title="结合专业的测评工具，对学生的职业兴趣类型、MBTI性格类型、能力优劣势等进行深入解读，分析学生在学科学习、人际沟通等方面特点。"
              >结合专业的测评工具，对学生的职业兴趣类型、MBTI性格类型、能力优劣势等进行深入解读，分析学生在学科学习、人际沟通等方面特点。</p>
          </div>
        </div>
        <div class="center">
          <div class="rightArrows">
            <img src="../../assets/img/gaobao/jt.png" alt="">
          </div>
        </div>
        <div class="bottom">
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/b.png" alt="">
              <span>录取结果跟踪</span>
            </div>
            <p
              title="指导学生和家长网上填报志愿，并跟踪大学和专业录取结果，对学业生涯规划进行指导，帮助考生在大学更好发展。"
              >指导学生和家长网上填报志愿，并跟踪大学和专业录取结果，对学业生涯规划进行指导，帮助考生在大学更好发展。</p>
          </div>
          <div class="rightArrows">
            <img src="../../assets/img/gaobao/jt.png" alt="">
          </div>
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/b.png" alt="">
              <span>志愿方案确定</span>
            </div>
            <p
              title="结合学生高考成绩、位次以及目标专业、目标大学、冲稳保策略，为学生量身定制志愿填报方案，为学生和家长解读志愿填报方案设计思路，并结合学生和家长的意见调整优化志愿填报方案。"
              >结合学生高考成绩、位次以及目标专业、目标大学、冲稳保策略，为学生量身定制志愿填报方案，为学生和家长解读志愿填报方案设计思路，并结合学生和家长的意见调整优化志愿填报方案。</p>
          </div>
          <div class="rightArrows">
            <img src="../../assets/img/gaobao/jt.png" alt="">
          </div>
          <div class="box">
            <div class="name">
              <img src="../../assets/img/gaobao/b.png" alt="">
              <span>大学、专业目标定位</span>
            </div>
            <p
              title="结合学生学科特长以及兴趣、性格、能力特点、未来发展规划，推荐适合学生选择的专业（类）和大学，初步拟定志愿方案。"
              >结合学生学科特长以及兴趣、性格、能力特点、未来发展规划，推荐适合学生选择的专业（类）和大学，初步拟定志愿方案。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="teamBox">
      <div class="title">专业的服务团队</div>
      <div class="teamListBox">
        <div class="left" @click="slideLeft(teamStyle.left)">
          <div class="block"></div>
        </div>
        <div class="members">
          <div class="teamMemberListBox" :style="teamStyle">
            <div
              class="memberBox"
              v-for="(item,index) in memberList"
              :key="index">
              <div class="img" @mouseenter="isInfoShow = item.name" @mouseleave="isInfoShow = ''">
                <img :src="item.img" alt="">
                <div class="info" v-show="isInfoShow===item.name">
                  <h4>{{item.name}}</h4>
                  <ul
                    v-for="(i,n) in item.infoList"
                    :key="n">
                    <li>{{i}}</li>
                  </ul>
                </div>
              </div>
              <p>
                <span class="name" v-text="item.name"></span>
                <span class="job" v-text="item.job"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="right" @click="slideRight(teamStyle.left)">
          <div class="block"></div>
        </div>
      </div>
    </div>
    <div class="informationCollect">
      <div class="title">欢迎咨询</div>
      <div class="info" style="font-size: 14px">客服电话：400-0127-985 或留下您的信息，我们安排专人与您联系. </div>
      <informationCollect />
    </div>
    <footer>
      <foot-component />
    </footer>

  </div>
</template>

<script>
  import informationCollect from './children/informationCollect.vue'
  import headComponent from '../../components/head.vue'
  import footComponent from '../../components/foot.vue'
  export default {
    name: "seniorVolunteer",  // 高报
    data() {
      return {
        sliderList: [
          {
            title: '高考志愿填报',
            info: '<p>专业力量·决胜高考</p><p>为了目标，需要专业的服务</p>',
            src: require('../../assets/img/gaobao/zytb_banner1.png')
          }
        ],
        helpList: [
          {
            src: require('../../assets/img/gaobao/swc.png'),
            name: '上网查？',
            text: '打开意向学校官网，了解院校介绍、院校最近几年分数线，如果合适就填'
          },
          {
            src: require('../../assets/img/gaobao/xqy.png'),
            name: '询亲友？',
            text: '哪个亲戚家的孩子上了好大学，他们懂得多，去打听一下，也许能帮忙填个志愿'
          },
          {
            src: require('../../assets/img/gaobao/wls.png'),
            name: '问老师？',
            text: '高中三年任课老师对学生最了解，出分之后完全听取老师建议填报，总不会错'
          },
          {
            src: require('../../assets/img/gaobao/kmz.png'),
            name: '看名字？',
            text: '理工、科技、财政等气派字眼的高校名称，就觉得填这些学校不会错'
          },
        ],
        arrHelpList: [
            '盲目追求热门专业',
            '高分低报',
            '专业不喜欢'
        ],
        platformList: [
          {
            src: require('../../assets/img/gaobao/1.png'),
            name: '历年数据查询',
            url: '/stu/calendarYSummary'
          },
          {
            src: require('../../assets/img/gaobao/2.png'),
            name: '模拟志愿填报',
            url: '/stu/volunteerApply'
          },
          {
            src: require('../../assets/img/gaobao/3.png'),
            name: '生涯测评',
            url: '/stu/career-evaluation'
          },
          {
            src: require('../../assets/img/gaobao/4.png'),
            name: '认识大学',
            url: '/stu/college'
          },
          {
            src: require('../../assets/img/gaobao/5.png'),
            name: '认识专业',
            url: '/stu/major'
          },
          {
            src: require('../../assets/img/gaobao/6.png'),
            name: '认识职业',
            url: '/stu/job'
          }
        ],
        teamStyle: {
          width: '',
          left: '0px'
        },
        maxLeft: null,
        maxRight: 0,
        isInfoShow: '',  // 要显示成员信息的name
        memberList: [
          {
            name: '佀芒芒',
            img: require('../../assets/img/gaobao/t1.png'),
            job: '高考志愿规划师',
            infoList: [
                '复旦大学',
                '人力资源专家',
                '政府、多家事业单位、国企特聘顾问'
            ]
          },
          {
            name: '王艺瑾',
            img: require('../../assets/img/gaobao/t2.png'),
            job: '高考志愿规划师',
            infoList: [
                '中国人民大学硕士',
                '济南电台升学栏目特聘嘉宾',
                '多所大学校外指导老师'
            ]
          },
          {
            name: '刘建',
            img: require('../../assets/img/gaobao/t3.png'),
            job: '高考志愿规划师',
            infoList: [
                '大学生学业规划指导老师',
                '山东财经大学教师',
                '博士'
            ]
          },
          {
            name: '刘宸绮',
            img: require('../../assets/img/gaobao/t4.png'),
            job: '高考志愿规划师',
            infoList: [
              '南开大学',
              '15年人力资源管理经验',
              '家庭教育指导师',
              '企业人力资源顾问'
            ]
          },
          {
            name: '王卿',
            img: require('../../assets/img/gaobao/t5.png'),
            job: '高考志愿规划师',
            infoList: [
              '中国青少年研究会会员',
              '高级家庭教育指导师讲师',
              '中国关心下一代工作委员会课题组研究员'
            ]
          },
          {
            name: '焉文豪',
            img: require('../../assets/img/gaobao/t6.png'),
            job: '高考志愿规划师',
            infoList: [
                '企业高管',
                '山东大学',
                '大学生职业规划、创业导师'
            ]
          },
          {
            name: '许辰',
            img: require('../../assets/img/gaobao/t7.png'),
            job: '高考志愿规划师',
            infoList: [
              '管理咨询公司负责人',
              '全国知名职业培训师',
              '山东培训联合会副会长'
            ]
          },
          {
            name: '曲晓燕',
            img: require('../../assets/img/gaobao/t8.png'),
            job: '高考志愿规划师',
            infoList: [
              '财务总监',
              'CMA注册管理会计师',
              '税务师'
            ]
          },
          {
            name: '陈明丽',
            img: require('../../assets/img/gaobao/t9.png'),
            job: '高考志愿规划师',
            infoList: [
              '国家注册人力资源管理师',
              '埃里克森国际教练体系教练',
              '见智达·做到梦想教练'
            ]
          },
          {
            name: '陈雪',
            img: require('../../assets/img/gaobao/t10.png'),
            job: '高考志愿规划师',
            infoList: [
              '10年亲子教育经验',
              '国家认证家庭教育指导师',
              '国际认证心理咨询师'
            ]
          },
          {
            name: '张明媛',
            img: require('../../assets/img/gaobao/t11.png'),
            job: '高考志愿规划师',
            infoList: [
              '中国科学院心理研究所认证心理咨询师',
              '中国生命关怀协会心理健康专业委员会公益讲师'
            ]
          }
        ]
      }
    },
    components: {
      informationCollect,
      headComponent,
      footComponent,
    },
    mounted() {
      this.setWidth();
    },
    methods: {
      // 跳转路由
      jumpUrl(url) {
        this.$loading.show();
        let timer = setTimeout(() => {
          this.$loading.hide();
          this.$router.push(url);
          clearTimeout(timer)
        },1000)
      },
      // 专业团队list宽度
      setWidth() {
        this.teamStyle.width = this.memberList.length * 200 + 'px';
        this.maxLeft = 1200 - this.memberList.length * 200;
      },
      slideLeft(right) {
        let cd = Number(right.slice(0,right.indexOf('p')));
        if(cd < this.maxRight) {
          this.teamStyle.left = (cd + 200) + 'px'
        }
      },
      slideRight(left) {
        let cd = Number(left.slice(0,left.indexOf('p')));
        if(cd > this.maxLeft) {
          this.teamStyle.left = (cd - 200) + 'px'
        }
      }
    }
  }
</script>
<style lang="scss">
  .slider{
    p{
      margin: 0;
    }
  }
</style>
<style scoped lang="scss">
  @import "../../style/common.scss";
  .seniorVolunteer {
    .slider{
      height: 450px;
      background: #F6F7FA;
      .box{
        margin: auto;
        max-width: 1200px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        .left{
          padding-top: 160px;
          width: 50%;
          .title{
            font-size: 40px;
            font-weight: 500;
            color: rgba(27, 28, 50, 0.85);
          }
          .text{
            margin-top: 30px;
            font-size: 30px;
            font-weight: 400;
            color: rgba(27, 28, 50, 0.85);
          }
        }
        .right{
          .img{
            width: 480px;
            height: 340px;
            overflow: hidden;
            margin-top: 60px;
            margin-right: 60px;
            img{
              height: 100%;
            }
          }
        }
      }
    }
    .help{
      height: 858px;
      background-color: #ffffff;
      .title{
        padding: 60px 0 40px;
        h4{
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: rgba(27, 28, 50, 0.85);
        }
      }
      .content{
        max-width: 1200px;
        margin: auto;
        .helpListBox{
          display: flex;
          .box{
            text-align: center;
            width: 25%;
            .img{
              img{
                margin: 10px;
              }
              margin: 30px;
            }
            .name{
              font-size: 20px;
              font-weight: 400;
              color: #39425E;
              margin-bottom: 10px;
            }
            p{
              padding: 0 40px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(27, 28, 50, 0.65);
            }
          }
        }
        .arrHelpListBox{
          display: flex;
          justify-content: center;
          margin: 50px 0 30px;
          .box{
            height: 40px;
            line-height: 40px;
            display: flex;
            margin: 0 20px;
            img{
              margin-top: 7px;
              height: 26px;
              line-height: 40px;
            }
            span{
              font-size: 24px;
              display: inline-block;
              height: 40px;
              line-height: 40px;
              font-weight: 400;
              color: #FF0200;
            }
          }
        }
        .info{
          text-align: center;
          p{
            font-size: 20px;
            font-weight: 400;
            color: #39425E;
            margin-bottom: 10px;
          }
        }
      }
    }
    .platform{
      background: #F6F7FA;
      padding: 100px 0 60px;
      .title{
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
        text-align: center;
      }
      .info{
        margin: 40px 0;
        text-align: center;
        i,span{
          font-size: 30px;
          font-weight: 400;
          color: #7CB305;
        }
        i{
          margin-right: 8px;
        }
      }
      .listBox{
        display: flex;
        justify-content: space-between;
        max-width: 1200px;
        margin: auto;
        .box{
          min-width: 140px;
          text-align: center;
          .img{
            img{
              cursor: pointer;
            }
          }
          .name{
            font-size: 20px;
            font-weight: 400;
            color: #39425E;
            margin-top: 20px;
          }
        }
      }
    }
    .serveBox{
      background-color: #fff;
      padding: 60px 0;
      .title{
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
        text-align: center;
      }
      .info{
        margin: 40px 0;
        text-align: center;
        i,span{
          font-size: 30px;
          font-weight: 400;
          color: #7CB305;
        }
        i{
          margin-right: 8px;
        }
      }
      .serveListBox{
        max-width: 1200px;
        margin: auto;
        .box{
          width: 320px;
          height: 207px;
          background: rgba(89, 126, 247, 0.1);
          border-radius: 6px;
          .name{
            display: flex;
            margin-top: 30px;
            padding-left: 30px;
            margin-bottom: 10px;
            line-height: 26px;
            height: 26px;
            text-align: center;
            img{
              margin-right: 4px;
            }
            span{
              font-size: 20px;
              font-weight: 400;
              color: #39425E;
            }
          }
          p{
            padding: 0 30px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(27, 28, 50, 0.65);
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            overflow: hidden;
          }
        }
        .top{
          display: flex;
          justify-content: space-around;
          .rightArrows{
            line-height: 207px;
          }
        }
        .center{
          .rightArrows{
            margin: 30px 0;
            text-align: right;
            img{
              margin-right: 140px;
              transform:rotate(90deg);
            }
          }
        }
        .bottom{
          display: flex;
          justify-content: space-around;
          .rightArrows{
            line-height: 207px;
            img{
              transform:rotate(180deg);
            }
          }
        }
      }
    }
    .teamBox{
      padding: 60px 0;
      background: #F6F7FA;
      .title{
        text-align: center;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .teamListBox{
        display: flex;
        justify-content: center;
        .left, .right{
          line-height: 400px;
          .block{
            display: inline-block;
            width: 70px;
            height: 70px;
            transform:rotate(45deg);
            cursor: pointer;
          }
        }
        .left{
          .block{
            border-bottom: 3px solid #ddd;
            border-left: 3px solid #ddd;
          }
          .block:hover{
            border-bottom: 3px solid #999;
            border-left: 3px solid #999;
          }
        }
        .right{
          .block{
            border-top: 3px solid #ddd;
            border-right: 3px solid #ddd;
          }
          .block:hover{
            border-top: 3px solid #999;
            border-right: 3px solid #999;
          }
        }
      }
      .members{
        position: relative;
        /*border: 1px solid red;*/
        width: 1200px;
        height: 400px;
        margin: 30px 0;
        overflow: hidden;
        .teamMemberListBox{
          display: flex;
          height: 400px;
          position: absolute;
          top: 0;
          transition: all 0.5s;
          .memberBox{
            display: inline-block;
            border: 1px solid #f0f0f0;
            border-radius: 8px;
            overflow: hidden;
            width: 190px;
            margin: 0 5px;
            .img{
              height: 320px;
              overflow: hidden;
              position: relative;
              cursor: pointer;
              img{
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%);
                height: 100%;
              }
              .info{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.6);
                padding: 20px 8px;
                h4{
                  color: #f0f0f0;
                  font-size: 18px;
                  font-weight: normal;
                  margin-bottom: 8px;
                }
                ul{
                  li{
                    color: #aaa;
                  }
                }
              }
            }
            p{
              margin: 16px 0;
              padding: 0 10px;
              span.name{
                margin-right: 10px;
                font-size: 20px;
                font-weight: 400;
                color: #39425E;
              }
              span.job{
                font-size: 14px;
                font-weight: 400;
                color: rgba(57, 66, 94, 0.65);
              }
            }
          }
        }
      }
    }
    .informationCollect{
      padding: 60px 0;
      background-color: #fff;
      .title{
        text-align: center;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .info{
        margin: 40px 0;
        text-align: center;
        font-size: 30px;
        font-weight: 400;
        color: #FF0200;
      }
    }
  }
</style>
